export enum FilterTypeEnum {
  DATE = 'date',
  DATE_RANGE = 'dateRange',
  REALTIME = 'realtime',
  REGULAR = 'regular',
}
